/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { Card, Button, TextArea, Intent, NonIdealState, Switch } from '@blueprintjs/core';
import { MTree } from '@moleculeone/tree';
import { Pagination, SynthesisTree } from '@moleculeone/ui';

import { smilesToMol } from '@f/utils/conversion';
import ContextToolbox from '@f/components/shared/molecule/ContextToolbox';
import { DownloadSynthesisPopover } from '@f/components/shared/download-synthesis-popover/DownloadSynthesisPopover';
import { useIsDebugModeOn } from '@f/hooks/useIsDebugModeOn';

import { DebugTreeLabel } from '../../batch-searches/pages/single-batch-search/components/DebugTreeLabel';
import { ReferenceReactionTreeButton } from '../../batch-searches/pages/single-batch-search/components/ReferenceReactionTreeButton';

import cls from './SynthesisBrowser.module.css';

async function buildFromSynthesisData(source) {
  if (!source) {
    return;
  }

  const mtree = await MTree.parseSynthesis(source, smilesToMol);
  return mtree.serialize();
}

export default function SynthesisBrowser() {
  const [input, setInput] = React.useState('');
  const [source, setSource] = React.useState([]);
  const [tree, setTree] = React.useState();
  const [synthesisIdx, setSynthesisIdx] = React.useState(0);
  const [showReferences, setShowReferences] = React.useState(true);

  const isDebugModeOn = useIsDebugModeOn();

  const changeTree = nextIdx => {
    setSynthesisIdx(nextIdx);
    setTree(undefined);
    buildFromSynthesisData(source[nextIdx]).then(tree => setTree(tree));
  };

  useEffect(() => {
    const input = window.localStorage.getItem('synthesis-browser-last-input');

    if (!input) {
      return;
    }

    const source = JSON.parse(input);
    setInput(input);
    setSource(source);
    setSynthesisIdx(0);
    buildFromSynthesisData(source[0]).then(tree => setTree(tree));
  }, []);

  useEffect(() => {
    changeTree(0);
  }, [source]);

  return (
    <div className={cls.container}>
      <div className={cls.inputContainer}>
        <TextArea
          fill
          rows={6}
          placeholder="Paste synthesis data here..."
          value={input}
          onChange={event => {
            setInput(event.target.value);
          }}
        />

        <Button
          large
          intent={Intent.PRIMARY}
          text="Load"
          icon="import"
          onClick={() => {
            try {
              setSource(JSON.parse(input));
              window.localStorage.setItem('synthesis-browser-last-input', input);
            } catch (error) {
              console.error(error);
            }
          }}
        />
      </div>

      <div className={cls.section}>
        <Switch
          style={{ marginBottom: 0 }}
          checked={showReferences}
          onChange={() => {
            setShowReferences(prev => !prev);
          }}
          label="Show references"
        />
        <Pagination
          currentPage={synthesisIdx + 1}
          itemCount={source.length}
          pageSize={1}
          onChange={nextIdx => {
            changeTree(nextIdx - 1);
          }}
        />
      </div>

      <Card className={cls.synthesis}>
        <div className={cls.cardHeader}>
          <small className={cls.label}>SYNTHESIS</small>

          {source.length > 0 && isDebugModeOn && <DownloadSynthesisPopover synthesis={source[synthesisIdx]} />}
        </div>
        <div className={cls.treeContainer}>
          {source.length === 0 && <NonIdealState title="No synthesis data loaded" icon="search" />}

          {tree && (
            <SynthesisTree
              key={synthesisIdx}
              tree={tree}
              renderPointContext={{
                common: showReferences && ReferenceReactionTreeButton,
                debug: DebugTreeLabel,
              }}
              renderMoleculeContext={ContextToolbox}
              debugEnabled={isDebugModeOn}
              synthesis={source[synthesisIdx]}
            />
          )}
        </div>
      </Card>

      <Pagination
        currentPage={synthesisIdx + 1}
        itemCount={source.length}
        pageSize={1}
        onChange={nextIdx => {
          changeTree(nextIdx - 1);
        }}
      />
    </div>
  );
}
